import React, { memo } from 'react'
import { Alert, AlertTitle } from '@mui/material'

import { numberCeil } from '../../util/number.helpers'
import { formatTicks } from '../../util/string.helpers'
import customConfig from 'customConfig'
import SubmitButton from '../shared/button/SubmitButton'

const CancelListing = ({
  t,
  onCancelListing,
  nftForSale,
  sellNftProfile,
  tokenProfile: { onramp, symbol },
  loading
}) => {
  const { numberOfPoints, stopSaleDisabled } = sellNftProfile
  return (
    <Alert severity='info' sx={{ width: '100%' }}>
      <AlertTitle>{t(customConfig.sellYourNftLabel)}</AlertTitle>
      <div>
        {t(customConfig.stopNftSaleDescLabel, {
          points:
            numberOfPoints && numberOfPoints >= 0
              ? formatTicks(numberOfPoints)
              : formatTicks(numberCeil(nftForSale?.usdPrice / onramp)),
          symbol
        })}
      </div>
      <SubmitButton
        type='button'
        label={t('nft.stop-sale')}
        disabled={stopSaleDisabled}
        loading={loading}
        onClick={onCancelListing}
        size='default'
        sx={{ mt: 2 }}
      />
    </Alert>
  )
}

export default memo(CancelListing)
